module.exports = __webpack_public_path__ + "static/media/watercolour.d0af64a2.jpg";